var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.onCartClicked}},[_c('el-badge',{staticClass:"badge",attrs:{"value":_vm.docSize,"hidden":_vm.docSize <= 0}},[_c('i',{staticClass:"icon el-icon-shopping-cart-full"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }